var ApplicantAPI = require("../../common/api").Applicant;
var ApplicantLegalStatusAPI = require("../../common/api/applicantLegalStatuses");
var enums = require("../../common/enums");
var Promise = require("bluebird");
var _ = require("underscore");
var moment = require("moment");


module.exports = function ($scope, $stateParams, ngDialog) {

    var vm = this;
    vm.OrganisationManagementType = enums.OrganisationManagementType;
    vm.OrganisationType = enums.OrganisationType;
    vm.directlyBenefitting = enums.NumberOfPeopleLarge;
    vm.numberOfPages = 0;
    vm.pageSize = 6;
    vm.pageNumber = 1;
    vm.legalStatus = "";
    vm.applicantId = "";
    vm.organisation = {};
    vm.isOwner = true;
    vm.isAddInfoOpen = true;
    vm.galleryItems = [{}];
    vm.applicantId = null;

    var init = function () {
        vm.loading = true;
        ApplicantAPI.GetApplicantByUserRef($stateParams.userRef).then(function (result) {
            vm.applicantId = result.applicantId;
            Promise.join(
                ApplicantAPI.GetApplicantById(vm.applicantId, "ApplicantPublicOrganisationView"),
                ApplicantLegalStatusAPI.GetApplicantLegalStatusTypes(),
                function (applicantDetails, orgStatusTypes) {
                    vm.applicantOrgStatusTypes = orgStatusTypes.results;
                    if (applicantDetails) {
                        vm.loading = false;
                        vm.applicant = applicantDetails;
                        vm.applicant.userRef = $stateParams.userRef;
                    }
                });
            vm.getApplications();
        });
    };

    if (vm.galleryItems.length > 0) {
        vm.galleryItemsShow = true;
    } else {
        vm.galleryItemsShow = false;
    }

    vm.getDescription = function (enm, id) {
        for (var i = 0; i < enm.length; i++) {
            var item = enm[i];
            if (item.id == id)
                return item.description;
        }
        return null;
    };

    vm.getApplications = function () {
        ApplicantAPI.GetProjects(vm.applicantId, null, null, vm.pageNumber, vm.pageSize).then(function (result) {
            vm.applications = result.results;
            vm.totalApplications = result.totalResults;
            if (vm.applications && vm.applications.length > 0) {
                vm.numberOfPages = Math.ceil(vm.totalApplications / vm.pageSize);
                vm.applications.forEach(function (app) {
                    app.percentage = 0;
                    if (!app.grandTotalRaised && !app.totalRequested && !app.totalExternallyRaised) {
                        return;
                    }
                    app.percentage = Math.floor((app.grandTotalRaised / (app.totalRequested + app.totalExternallyRaised)) * 100);
                    if (app.percentage > 100) {
                        app.percentage = 100;
                    }
                });
            }
        });
    };
    vm.pageChange = function (next, prev) {
        vm.pageNumber = next;
        vm.getApplications();
    };
    vm.toggle = function () {
        vm.isAddInfoOpen = !vm.isAddInfoOpen;
    };
    vm.openApplicantSummary = function () {
        var dialog = ngDialog.open({
            template: require("./dialogs/applicantSummary.pug")(),
            controller: require("./dialogs/applicantSummary"),


            plain: true,
            disableAnimation: true,
            className: "ge-dialog-medium ngdialog-theme-default",
            resolve: {
                applicantSummary: function () { return vm.applicant.about }
            }
        });
        dialog.closePromise.then(function (data) {
            if (data.value.action == "submit") {
                vm.applicant.about = data.value.applicantSummary;
                return ApplicantAPI.UpdateApplicant(vm.applicant).then(function () {
                    return init();
                });
            }
        });
    };

    var dialogs = {
        gallery: {
            template: require("./dialogs/gallery.pug")(),
            controller: require("./dialogs/gallery")
        },
        video: {
            template: require("./dialogs/video.pug")(),
            controller: require("./dialogs/video")
        }
    };
    var addGalleryItemModalCallback = function (data) {
        var item = data.value.item;
        if (item) {
            ApplicantAPI.AddGalleryItem(vm.applicantId, item).then(function (result) {
                // item.id = result;
                init();
            });
        }
    };
    vm.addGalleryVideo = function () {
        var item = {};
        var dialog = openGalleryDialog(item, "video");

        dialog.closePromise.then(addGalleryItemModalCallback);
    };

    var openGalleryDialog = function (item, dialogName) {
        if (!dialogName)
            dialogName = "gallery";
        var template = dialogs[dialogName].template;
        var controller = dialogs[dialogName].controller;
        var dialog = ngDialog.open({
            template: template,
            controller: controller,
            plain: true,
            closeByDocument: false,
            disableAnimation: true,
            resolve: {
                item: function () {
                    return item;
                }
            }
        });
        return dialog;
    };

    vm.addGalleryItem = function () {
        var item = {};
        var dialog = openGalleryDialog(item);
        dialog.closePromise.then(addGalleryItemModalCallback);
    };

    vm.editGalleryItem = function (item, event) {
        event.preventDefault();
        event.stopPropagation();
        var modalType = "gallery";
        if (item.isVideo)
            modalType = "video";
        var dialog = openGalleryDialog(_.clone(item), modalType);
        dialog.closePromise.then(function (data) {
            var item = data.value.item;

            if (item) {
                item.createdDate = moment().format("YYYY-MM-DDThh:mm:ss");
                _.extend(_.findWhere(vm.applicant.applicantGalleryItems, { id: item.id }), item);
                ApplicantAPI.UpdateGalleryItem(vm.applicantId, item.id, item).then(function (result) {
                    item.id = result;
                });
            }
        });
    };

    vm.deleteGalleryItem = function (item, event) {
        event.preventDefault();
        event.stopPropagation();
        var promise = ngDialog.openConfirm({
            template: "\
                <p>Are you sure you want to delete this item?</p>\
                <div class=\"ngdialog-buttons clearfix\">\
                    <button type=\"button\" class=\"btn btn-green btn-sm pull-xs-right m-l-1\" ng-click=\"closeThisDialog(0)\">No</button>\
                    <button type=\"button\" class=\"btn btn-danger btn-sm pull-xs-right\" ng-click=\"confirm(1)\">Yes</button>\
                </div>",
            plain: true,
            disableAnimation: true
        });
        promise.then(function () {
            ApplicantAPI.DeleteGalleryItem(vm.applicantId, item.id).then(function () {
                init();
            });
        });
    };

    init();
};
